var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllbookAuthor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6482_702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 16.2501V3.75008C3.33398 3.19755 3.55348 2.66764 3.94418 2.27694C4.33488 1.88624 4.86478 1.66675 5.41732 1.66675H15.834C16.055 1.66675 16.267 1.75455 16.4232 1.91083C16.5795 2.06711 16.6673 2.27907 16.6673 2.50008V17.5001C16.6673 17.7211 16.5795 17.9331 16.4232 18.0893C16.267 18.2456 16.055 18.3334 15.834 18.3334H5.41732C4.86478 18.3334 4.33488 18.1139 3.94418 17.7232C3.55348 17.3325 3.33398 16.8026 3.33398 16.2501ZM3.33398 16.2501C3.33398 15.6975 3.55348 15.1676 3.94418 14.7769C4.33488 14.3862 4.86478 14.1667 5.41732 14.1667H16.6673",
    stroke: "#19CF7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6482_702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllbookAuthor);
export default __webpack_public_path__ + "static/media/allbook_author.e36cac0197595174940eefe364bcad84.svg";
export { ForwardRef as ReactComponent };